import { useCallback, useSyncExternalStore } from 'react'
import { tokenStore } from '@/lib/auth/tokenStore'
import {
  adoptPlatformSession,
  resetSessionAdoption,
} from '@/lib/auth/sessionAdoption'

/** Solo para tests: repermite el intento de refresh silencioso. */
export function resetSessionProbe(): void {
  resetSessionAdoption()
}

/**
 * Sesión del portal en páginas PÚBLICAS (landing, /actualizaciones), donde no
 * corre `RequireAuth`. `token`/`isLoggedIn` reaccionan al tokenStore;
 * `ensureSession()` delega en la adopción de sesión de plataforma
 * (`adoptPlatformSession`, única sonda por carga de página — compartida con
 * el boot de AppProviders) y devuelve el token o null — el null se trata como
 * anónimo, nunca rompe la página (fallback previsto en el goal).
 */
export function usePortalSession() {
  const token = useSyncExternalStore(
    (onChange) => tokenStore.subscribe(onChange),
    () => tokenStore.get(),
  )

  const ensureSession = useCallback(
    (): Promise<string | null> => adoptPlatformSession(),
    [],
  )

  return { token, isLoggedIn: !!token, ensureSession }
}
